import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const Card = (props) => {
  const { title, subtitle, listArr, hasBg } = props;

  return (
    <div
      className="auth0-card"
      style={
        hasBg && {
          backgroundImage: `url("http://files.authing.co/authing-website/auth0-replace-bg.png")`,
          backgroundSize: "cover",
        }
      }
    >
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
      {listArr.map((list) => (
        <div className="card-list">
          <div className="card-list-top">
            <div className="card-list-icon">
              <img
                src={`http://files.authing.co/authing-website/${list.icon}`}
                alt="auting"
              />
            </div>
            <div>{list.title}</div>
          </div>
          <div className="card-list-description">{list.description}</div>
        </div>
      ))}
    </div>
  );
};

export const ReplaceAuth0 = (props) => {
  const { t } = useTranslation();
  const CardData = [
    {
      title: t("solution.auth0.replace.authing.title"),
      subtitle: t("solution.auth0.replace.authing.subtitle"),
      hasBg: true,
      listArr: [
        {
          icon: "auth0-icon1-fill.png",
          title: t("solution.auth0.replace.authing.item1.title"),
          description: t("solution.auth0.replace.authing.item1.descript"),
        },
        {
          icon: "auth0-icon2-fill.png",
          title: t("solution.auth0.replace.authing.item2.title"),
          description: t("solution.auth0.replace.authing.item2.descript"),
        },
        {
          icon: "auth0-icon3-fill.png",
          title: t("solution.auth0.replace.authing.item3.title"),
          description: t("solution.auth0.replace.authing.item3.descript"),
        },
        {
          icon: "auth0-icon4-fill.png",
          title: t("solution.auth0.replace.authing.item4.title"),
          description: t("solution.auth0.replace.authing.item4.descript"),
        },
      ],
    },
    {
      title: t("solution.auth0.replace.auth0.title"),
      subtitle: t("solution.auth0.replace.auth0.subtitle"),
      listArr: [
        {
          icon: "auth0-icon1-unfill.png",
          title: t("solution.auth0.replace.auth0.item1.title"),
          description: t("solution.auth0.replace.auth0.item1.descript"),
        },
        {
          icon: "auth0-icon2-unfill.png",
          title: t("solution.auth0.replace.auth0.item2.title"),
          description: t("solution.auth0.replace.auth0.item2.descript"),
        },
        {
          icon: "auth0-icon3-unfill.png",
          title: t("solution.auth0.replace.auth0.item3.title"),
          description: t("solution.auth0.replace.auth0.item3.descript"),
        },
        {
          icon: "auth0-icon4-unfill.png",
          title: t("solution.auth0.replace.auth0.item4.title"),
          description: t("solution.auth0.replace.auth0.item4.descript"),
        },
      ],
    },
  ];
  return (
    <div>
      <section className="replace-auth0">
        <div className="inner">
          <div className="title">{t("solution.auth0.replace.title")}</div>
          <div className="subtitle">{t("solution.auth0.replace.subtitle")}</div>
          <div className="auth0-card-warp">
            {CardData.map((item) => (
              <Card {...item} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
